import { clientSideMetrics } from '@marketplace-web/observability/client-metrics-util'

const REQUEST_BLOCKED_BY_DATADOME_METRIC = 'frontend_request_blocked_by_datadome'
const DATADOME_CAPTCHA_FAILED_TO_RENDER_METRIC = 'frontend_datadome_captcha_failed_to_render'

export const incrementDataDomeRequestBlocked = () => {
  clientSideMetrics.counter(REQUEST_BLOCKED_BY_DATADOME_METRIC).increment()
}

export const incrementDataDomeScriptMissing = () => {
  clientSideMetrics.counter(DATADOME_CAPTCHA_FAILED_TO_RENDER_METRIC).increment()
}
